/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreMenuDto } from '../../models/store-menu-dto';

export interface InfoControllerGetStoreMenuV1$Params {
}

export function infoControllerGetStoreMenuV1(http: HttpClient, rootUrl: string, params?: InfoControllerGetStoreMenuV1$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreMenuDto>> {
  const rb = new RequestBuilder(rootUrl, infoControllerGetStoreMenuV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreMenuDto>;
    })
  );
}

infoControllerGetStoreMenuV1.PATH = '/api/v1/info/store-menu';
